const ChargesType = {

    // FIELDS
    "name": "Name",
    "cycle_type": "Cycle Type",
    "status": "Status",
    "cyclic": "Cyclic",
    "non_cyclic": "Non Cyclic",
    "search": "Search",

    // PAGE HEADER
    "chargesType": "Charges Type",

    // ERROR
    "error_name": "Enter Name",
    "error_cycle_type": "Select Cycle Type",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_cycle_type": "CYCLE TYPE",
    "table_status": "STATUS",

}

export default ChargesType;